import React from 'react';
import Editor from 'react-simple-code-editor';
import Prism from 'prismjs';
import './prism.css';

const style = {
  minHeight: "250px",
  margin: "10px 0",
  border: "1px solid #DEDEDE",
  fontFamily: "monospace"
};

export default (props) => {
  return (
    <Editor
    highlight={code => Prism.highlight(code, Prism.languages.html, 'html')}
    {...props}
    style={style}
    />
  )
}



// WEBPACK FOOTER //
// ./src/components/TemplateEditor/TemplateEditor.jsx